import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../less/IdStyles";
import { selectLastModalId } from "../../selectors/selectModalTabId";
import { selectIsTutorialActive } from "../../selectors/selectTutorial";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdSoundGroup } from "../../utils/sound/IdSoundGroup";
import { utilCompatibility } from "../../utils/utilCompatibility";
import { HudToggleFullscreen } from "../fullscreen/HudToggleFullscreen";
import { HudOptionButton } from "../generic/hud-option-button/HudOptionButton";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionLandingPageLogout } from "../landing-page/actionLandingPage";
import { HudToggleSound } from "../sound/HudToggleSound";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
import { actionViewportZoomIn, actionViewportZoomOut } from "../viewport/actionViewport";
export var HudTopRightOptionsDOM = function (_a) {
    var onZoomIn = _a.onZoomIn, onZoomOut = _a.onZoomOut, onLogOut = _a.onLogOut, isTutorialActive = _a.isTutorialActive, isModalOpen = _a.isModalOpen;
    var buttonsClassName = "hud-options__button-space-bottom";
    var showOptionOnTopClass = isTutorialActive ? "hud-options__on-top" : IdStyles.Empty;
    if (isModalOpen) {
        showOptionOnTopClass = showOptionOnTopClass + " modal-open";
    }
    return (React.createElement("div", { className: "flex flex--row hud-options__top-right" },
        React.createElement("div", { style: utilCompatibility.getMsGridPositions(0, 3) },
            React.createElement(TooltipText, { anchor: IdTooltipAnchor.Right, id: IdLoca.tooltip_hud_zoomout_web, className: buttonsClassName },
                React.createElement(HudOptionButton, { icon: IdIcon.OptionsZoomOutIcn, onClick: onZoomOut }))),
        React.createElement("div", { style: utilCompatibility.getMsGridPositions(1, 3) },
            React.createElement(TooltipText, { anchor: IdTooltipAnchor.Right, id: IdLoca.tooltip_hud_zoomin_web, className: buttonsClassName },
                React.createElement(HudOptionButton, { icon: IdIcon.OptionsZoomInIcn, onClick: onZoomIn }))),
        React.createElement("div", { style: utilCompatibility.getMsGridPositions(2, 3), className: showOptionOnTopClass },
            React.createElement(TooltipText, { anchor: IdTooltipAnchor.Right, id: IdLoca.tooltip_hud_fullscreen_web, className: buttonsClassName },
                React.createElement(HudToggleFullscreen, null))),
        React.createElement("div", { style: utilCompatibility.getMsGridPositions(3, 3), className: showOptionOnTopClass },
            React.createElement(HudToggleSound, { soundGroupId: IdSoundGroup.Sound })),
        React.createElement("div", { style: utilCompatibility.getMsGridPositions(4, 3), className: showOptionOnTopClass },
            React.createElement(HudToggleSound, { soundGroupId: IdSoundGroup.Music })),
        React.createElement("div", { style: utilCompatibility.getMsGridPositions(5, 3) },
            React.createElement(TooltipText, { anchor: IdTooltipAnchor.Right, id: IdLoca.tooltip_hud_logout_web, className: buttonsClassName },
                React.createElement(HudOptionButton, { icon: IdIcon.OptionsLogOutIcn, onClick: onLogOut })))));
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onLogOut: actionLandingPageLogout,
        onZoomIn: actionViewportZoomIn,
        onZoomOut: actionViewportZoomOut,
    }, dispatch);
};
var mapState = function (state) { return ({
    isModalOpen: !!selectLastModalId(state),
    isTutorialActive: selectIsTutorialActive(state),
}); };
export var HudTopRightOptions = connect(mapState, mapDispatch)(HudTopRightOptionsDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/options/HudTopRightOptions.tsx
// module id = 2315
// module chunks = 3